import Vue from "vue";

import {
  GET_MAPS,
  GET_MAIN_MAP_MOVE_END,
  GET_REMOVE_MAP,
  GET_MAP_REFRESH_DATA,
  GET_MAP_PING,
  GET_RESET_MAP_ICONS,
} from "./actions.type";
import {
  SET_MAPS,
  SET_MAIN_MAP_MOVE_END,
  SET_REMOVE_MAP,
  SET_MAP_REFRESH_DATA,
  SET_MAP_PING,
  SET_RESET_MAP_ICONS,
} from "./mutations.type";

const STATE = {
  maps: {},
  mainMapMoveEnd: null,
  refreshData: false,
  ping: {},
  resetMapIcons: null,
};

const GETTERS = {
  maps: (state) => state.maps,
  mainMapMoveEnd: (state) => state.mainMapMoveEnd,
  refreshData: (state) => state.refreshData,
  ping: (state) => state.ping,
  resetMapIcons: (state) => state.resetMapIcons,
};

const ACTIONS = {
  [GET_MAPS](context, data) {
    context.commit(SET_MAPS, data);
  },
  [GET_MAIN_MAP_MOVE_END](context, data) {
    context.commit(SET_MAIN_MAP_MOVE_END, data);
  },
  [GET_REMOVE_MAP](context, data) {
    context.commit(SET_REMOVE_MAP, data);
  },
  [GET_MAP_REFRESH_DATA](context, data) {
    context.commit(SET_MAP_REFRESH_DATA, data);
  },
  [GET_MAP_PING](context, data) {
    context.commit(SET_MAP_PING, data);
  },
  [GET_RESET_MAP_ICONS](context, data) {
    context.commit(SET_RESET_MAP_ICONS, data);
  },
};

const MUTATIONS = {
  [SET_MAPS](state, data) {
    if (data.id && data.map) {
      Vue.set(state.maps, data.id, data.map);
    }
  },
  [SET_MAIN_MAP_MOVE_END](state, data) {
    state.mainMapMoveEnd = data;
  },
  [SET_REMOVE_MAP](state, data) {
    if (data && state.maps[data]) {
      delete state.maps[data];
    }
  },
  [SET_MAP_REFRESH_DATA](state, data) {
    state.refreshData = data;
  },
  [SET_MAP_PING](state, data) {
    state.ping = data;
  },
  [SET_RESET_MAP_ICONS](state, data) {
    state.resetMapIcons = data;
  },
};

export default {
  namespaced: true,
  state: STATE,
  actions: ACTIONS,
  mutations: MUTATIONS,
  getters: GETTERS,
};
